import axios from "axios";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";

export const getUsersListApi = async (param) => {
  try {
    param.params.type = 2;
    const response = await axios({
      method: "POST",
      url: `${API_URL}all-users`,
      headers: { "Content-Type": "application/json" },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};
export const userRegisterApi = async (postData) => {
  try {
    postData.role = postData.role !== "" ? postData.role : "1";
    return await axios({
      method: "POST",
      url: `${API_URL}register`,
      data: {
        type: 2,
        email: postData.email,
        password: postData.password,
        first_name: postData.first_name,
        last_name: postData.last_name,
        role: postData.role,
      },
      headers: { "Content-Type": "application/json" },
    });
  } catch (e) {
    return e;
  }
};

export const addAzureAccountApi = async (postData) => {
  try {
    return await axios({
      method: "POST",
      url: `${API_URL}add-account`,
      data: {
        account_type: "azure",
        account_id: postData.account_id,
        account_name: postData.account_name,
        account_details: {
          directory_tenant_id: postData.directory_tenant_id,
          secrete_value: postData.secrete_value,
          secrete_id: postData.secrete_id,
          subscription_id: postData.subscription_id,
          valid_for: "12 months",
        },
      },
      headers: { "Content-Type": "application/json" },
    });
  } catch (e) {
    return e;
  }
};
export const userUpdateApi = async (postData) => {
  try {
    let paramsArr = {};
    paramsArr.type = 2;
    if (postData.new_password && postData.old_password) {
      paramsArr.password = postData.new_password;
      paramsArr.old_password = postData.old_password;
      paramsArr.new_password = postData.new_password;
      paramsArr.user_id = postData.userId;

      const response = await axios({
        method: "PUT",
        url: `${API_URL}password/update`,
        data: paramsArr,
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } else {
      paramsArr.user_id = postData.userId;
      paramsArr.first_name = postData.first_name;
      paramsArr.last_name = postData.last_name;
      paramsArr.role = postData.role;
      return await axios({
        method: "PUT",
        url: `${API_URL}user/update`,
        data: paramsArr,
        headers: { "Content-Type": "application/json" },
      });
    }
  } catch (e) {
    return e;
  }
};
export const forgotRequestApi = async (param) => {
  try {
    if (param && param.email) {
      const response = await axios({
        method: "POST",
        url: `${API_URL}password-reset-mail`,
        data: { type: 2, email: param.email },
        headers: { "Content-Type": "application/json" },
      });
      if (response.code === 200) {
        toast.success("Email sent successfully!");
      } else {
        toast.error("Please try again!");
      }
      if (response.code === 401) {
        toast.error(response.message);
      }
      return response;
    } else {
      const response = await axios({
        method: "POST",
        url: `${API_URL}password-reset`,
        data: { type: 2, token: param.token, password: param.new_password },
        headers: { "Content-Type": "application/json" },
      });
      if (response.code === 201) {
        toast.success("Password changed successfully!");
      } else {
        toast.error("Invalid token!");
      }
      if (response.code === 401) {
        toast.error(response.message);
      }
      return response;
    }
  } catch (e) {
    return e;
  }
};
